import { agoText } from "@/lib/tracking";
import { TrackMap } from "./TrackMap";

const pt = (a) => (a?.lat != null ? [a.lat, a.lng] : null);

export function LiveDelivery({ tr }) {
  const pos = tr.position;
  const who = tr.courier || "Entregador";
  return (
    <div className="space-y-2" data-testid="live-delivery">
      <TrackMap store={pt(tr.store)} dest={pt(tr.dest)} courier={pt(pos)} courierLabel={who} className="h-[260px]" />
      <p className="text-center text-xs text-slate-500" data-testid="live-delivery-status">{pos ? `${who} a caminho · ${agoText(pos.at)}` : "Aguardando a localização do entregador…"}</p>
    </div>
  );
}
